import { Injectable } from '@angular/core';
import { ApiEndpointConfigService } from './api-endpoint-config.service';

export enum AlgoliaHeaderKey {
  X_ALGOLIA_APP_ID = 'X-Algolia-Application-Id',
  X_ALGOLIA_API_ID = 'X-Algolia-API-Key',
}

@Injectable({
  providedIn: 'root',
})
export class ApiEndpointService {
  constructor(private readonly config: ApiEndpointConfigService) {}

  get accountsMsBaseUrl() {
    return `${this.config.msapiBaseUrl}v2/customer/accounts/`;
  }

  get accountsBaseUrl() {
    return `${this.config.msapiBaseUrl}ssc/accounts/v2/customer/accounts/`;
  }

  get deviceDetailsBaseUrl() {
    return `${this.config.msapiBaseUrl}ssc/device-details/v2/customer/accounts/`;
  }

  get contentBaseUrl() {
    return `${this.config.msapiBaseUrl}ssc/content/v2/customer/accounts/`;
  }

  get contentApiUrlUnauthenticated() {
    return `${this.config.msapiBaseUrl}ssc/content/v2/`;
  }

  get financedAccessoriesBaseUrl() {
    return `${this.config.msapiBaseUrl}ssc/accessories/v2/customer/accounts/`;
  }

  get wirelessBaseUrl() {
    return `${this.config.msapiBaseUrl}ssc/misc-wireless/v2/customer/accounts/`;
  }

  get algoliaBaseUrl() {
    return this.config.algoliaConfig.url;
  }

  get algoliaHeaders() {
    return {
      [AlgoliaHeaderKey.X_ALGOLIA_APP_ID]: this.config.algoliaConfig.appId,
      [AlgoliaHeaderKey.X_ALGOLIA_API_ID]: this.config.algoliaConfig.apiKey,
    };
  }

  get paymentBaseUrl() {
    return `${this.config.msapiBaseUrl}ssc/payment/v2/customer/accounts/`;
  }

  get promotionsBaseUrl() {
    return `${this.config.msapiBaseUrl}ssc/promotions/v2/customer/`;
  }
}
